export type TableProps = {
  data?: BudgetItemsType[];
};

export type BudgetItemsType = {
  codiPartida: string;
  partida: string;
  quantity: number | string;
  categoria: string;
  categoryColor?: string;
  unitPrice?: number;
  totalAmount?: number;
};

type columnIDTypes = { [key: string]: { id: string; label: string } };

export const columnNames: columnIDTypes = {
  codiPartida: {
    id: 'codiPartida',
    label: 'Codi partida',
  },
  partida: {
    id: 'partida',
    label: 'Partida',
  },
  quantity: {
    id: 'quantity',
    label: 'Quantitat',
  },
  categoria: {
    id: 'categoria',
    label: 'Categoria',
  },
  unitPrice: {
    id: 'unitPrice',
    label: 'Preu/Ud',
  },
  totalAmount: {
    id: 'totalAmount',
    label: 'Import',
  },
};
